import React from 'react';
import {Card, Grid} from "@mui/material";
import {useNavigate} from "react-router-dom";

const _epBanner = (banners) => {

    const navigate = useNavigate();
    const display = {xs:"none",sm:"none",md:"none"}
    return (
        <Grid>

            <Grid sx={{mt:4,mb:2}} direction={"row"} container justifyContent={"center"} >
                <Grid sx={{width:"100%"}}>
                    {banners?.Items?.map(item=>(
                        <Card onClick={()=>{navigate(item?.Data)}} sx={{display:{...display,[Object(item?.Description)]:"inherit"},borderRadius:4,mx:2}} elevation={4} >
                            <img width={"100%"} src={item?.multimedia?.Url}/>
                        </Card>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default _epBanner;
